export const iconFontAwesomeDesignWandMagicSparkles = (
	<i className="fa-solid fa-wand-magic-sparkles"></i>
);
